import { render, staticRenderFns } from "./ConnectorsPage.vue?vue&type=template&id=0f0a0812&"
import script from "./ConnectorsPage.vue?vue&type=script&lang=js&"
export * from "./ConnectorsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports